<aside
  class="course-navigation-panel"
  [class.collapsed]="collapsed()"
>
  <button
    type="button"
    class="panel-header"
    [attr.aria-label]="(collapsed()
      ? 'h5pPlayer.courseNavigation.expand'
      : 'h5pPlayer.courseNavigation.collapse') | translate"
    [attr.aria-expanded]="!collapsed()"
    [attr.aria-controls]="panelBodyId"
    (click)="toggle()"
  >
    <mat-icon class="toggle-icon size-m">menu_open</mat-icon>
    @if (!collapsed()) {
      <h2 class="panel-title">
        {{ 'h5pPlayer.courseNavigation.title' | translate }}
      </h2>
    }
  </button>

  <div [id]="panelBodyId" class="panel-body">
    @if (!collapsed()) {
      @for (section of viewModel(); track section.id) {
        <section class="nav-section">
          <h3 class="section-title">{{ section.title }}</h3>

          @for (item of section.items; track item.id) {
            @if (item.kind === ITEM_KINDS.LABEL) {
              <div
                class="label-row"
                [class.interactive]="item.overflowing()"
                [class.expanded]="item.textExpanded()"
                [attr.role]="item.overflowing() ? 'button' : null"
                [attr.tabindex]="item.overflowing() ? 0 : null"
                [attr.aria-expanded]="item.overflowing() ? item.textExpanded() : null"
                (click)="onLabelActivate(item)"
                (keydown.enter)="onLabelKeydown(item, $event)"
                (keydown.space)="onLabelKeydown(item, $event)"
              >
                <span
                  class="label-text"
                  appLabelOverflow
                  [expanded]="item.textExpanded()"
                  (overflowChange)="setLabelOverflowing(item.id, $event)"
                >{{ item.text || '-' }}</span>
                @if (item.overflowing()) {
                  <mat-icon class="label-chevron size-s">
                    {{ item.textExpanded() ? 'expand_less' : 'expand_more' }}
                  </mat-icon>
                }
              </div>
            } @else {
              <div
                class="module-row"
                [class.locked]="item.locked"
                [class.active]="item.active"
                [class.interactive]="!item.locked && !item.active"
                [attr.role]="!item.locked && !item.active ? 'button' : null"
                [attr.tabindex]="!item.locked && !item.active ? 0 : null"
                [attr.aria-disabled]="item.locked ? true : null"
                (click)="onModuleActivate(item)"
                (keydown.enter)="onModuleKeydown(item, $event)"
                (keydown.space)="onModuleKeydown(item, $event)"
              >
                <span class="module-title">{{ item.title || '-' }}</span>
                <span class="module-type">{{ (item.typeKey | translate) || '-' }}</span>
              </div>
            }
          }
        </section>
      }
    }
  </div>
</aside>
